function Hello() {
  return (
    <div>
      {/* <h2>Hello Component</h2> */}
    </div>
  );
}

export default Hello;
